import { toast } from "react-toastify";

export function setupToast(): void {
  toast.configure({
    hideProgressBar: true,
    position: "top-center",
    draggable: false,
    className: "custom-toast-container",
    autoClose: 5000,
    closeButton: <i className="icon-close" />,
  });
}
